import { PATHS, PATHS_PARAMS } from "constants/PATHS";
import { getResource } from "services";

export function getPrivacyPolicy(lang, onSuccess, onFail) {
	const path = PATHS(PATHS_PARAMS.getPrivacyPolicy, lang, { lang: lang });
	getResource(path, onSuccess, onFail);
}
